export default "/dist/files/epingle.19b572bfb8b459a271ca5eb3bc45cfac.svg";